import { getCrossAppCache, setCrossAppCache } from '@/utils/cross-app-cache';
import { hydraUiApi } from '@/services/api';

export const sampleAccounts = async () => {
  const url = '/sample_accounts';
  const cachedSampleAccounts = getCrossAppCache(url);
  if (cachedSampleAccounts != null) {
    return cachedSampleAccounts;
  }
  const data = await hydraUiApi.accounts.getSampleAccounts({});
  setCrossAppCache({ key: url, value: data });
  return data;
};
